import { formatProgress } from "./constants";
export var getAriaSummary = function getAriaSummary(progressSummary, status, threshold) {
  if (progressSummary !== undefined) {
    return progressSummary;
  }

  var statusText = !!status ? status : 'neutral';

  if (threshold !== undefined) {
    return "".concat(statusText, " with threshold at ").concat(formatProgress(threshold), " percent.");
  }

  return "".concat(statusText);
};